import { DataService } from "@/services/data";
import { DeployPreview, DialerCampaign } from "@/types/dialer/workflow";
import { handle_dialer_error } from "@/utils/dialer-errors";
import { handle_success } from "@/utils/wretch";
import { Navigate, redirect, RouteObject } from "react-router-dom";

const CampaignRoutes: RouteObject[] = [
    {
        // The campaign list is served by `sf_like` from `CampaignConfig` now. The index is
        // kept as a redirect rather than removed: six breadcrumbs across the workflow,
        // simulator and card screens link here, and a redirect retires the URL without
        // editing screens that have nothing else to do with this change.
        index: true,
        element: <Navigate to="/dialer-campaigns" replace />
    },
    {
        // The bespoke console is the Operations tab of the generic campaign detail page.
        // Bookmarks and in-app links keyed by `code` land there without a second chrome.
        path: ":code",
        loader: async ({ params }) => {
            const campaign = (await DataService.client.url(`/dialer/campaigns/${params.code}/`).get().json()) as DialerCampaign;
            return redirect(`/dialer-campaigns/${campaign.id}/operations`);
        }
    },
    {
        // Resource route: the deploy dialog reads the preview here and posts here too.
        // Kept under `/outils/campagnes` because dialogs across the editor and the slot
        // tabs already target it; moving it would be a second change for no gain.
        path: ":code/deploiement",
        loader: async ({ params, request }) => {
            const url = new URL(request.url);
            const preview = (await DataService.client
                .url(`/dialer/campaigns/${params.code}/deploy-preview/?${url.searchParams.toString()}`)
                .get()
                .json()) as DeployPreview;
            return { preview };
        },
        action: async ({ params, request }) => {
            const data = await request.json();
            const action = new URL(request.url).searchParams.get("action") === "rollback" ? "rollback" : "deploy";
            try {
                return handle_success(await DataService.client.url(`/dialer/campaigns/${params.code}/${action}/`).post(data).json());
            } catch (error) {
                return handle_dialer_error(error);
            }
        }
    }
];

export default CampaignRoutes;
